import { render, staticRenderFns } from "./xiaoQuList.vue?vue&type=template&id=9c36f5a6&scoped=true"
import script from "./xiaoQuList.vue?vue&type=script&lang=js"
export * from "./xiaoQuList.vue?vue&type=script&lang=js"
import style0 from "./xiaoQuList.vue?vue&type=style&index=0&id=9c36f5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c36f5a6",
  null
  
)

export default component.exports